// extracted by mini-css-extract-plugin
module.exports = {"bottomLine":"Steps_bottomLine__15LX3","Steps":"Steps_Steps__2yet3","main":"Steps_main___t9Uy","item":"Steps_item__Rxh4A","name":"Steps_name__1uRf4"};